module.exports = __webpack_public_path__ + "img/+.1ac3218b.svg";